// This file is generated automatically by scripts/generate-icon.js. Don't modify it.

import Receipt from '../_raw/ui/icon_receipt.svg';
import withIconProps from '../withIconProps';

export default withIconProps(Receipt);
